export default "bid-price-unit = {$currency}/т\nbid-price-per-km-unit = {$currency}/т/км"